import React from 'react'
import Heading from '../heading';
import RichText from '../rich-text';
import Image from '@components/image'
import Button from "@components/button"

const NewHero = ({ heading, cards, bottomText }) => {
    return (
        <div className="w-full">
            <Heading level="2" className="flex justify-center text-center mb-4">
                {heading}
            </Heading>
            <div className="flex flex-col md:flex-row gap-y-6 md:gap-x-6">
                {cards &&
                    cards.map((card, index) => (
                        <div key={index} className="flex flex-col w-full md:w-[48.5%] min-h-[190px] md:min-h-[370px]">
                            <div className="relative mb-4 h-[190px] md:h-[370px]">
                                <Image
                                    image={card?.image}
                                    className="rounded-xl w-full h-full object-cover"
                                    altPrefix={`Image showcasing the ${card?.title}`}
                                />
                                <div className="absolute top-0 w-full h-full 
                                    bg-gradient-to-b 
                                    from-[rgba(0,0,0,0.8)] md:from-[rgba(0,0,0,0.6)]
                                    via-[rgba(0,0,0,0.3)] md:via-[rgba(0,0,0,0)]
                                    to-transparent 
                                    rounded-xl flex flex-col justify-end md:justify-start 
                                    items-left md:items-center p-5">

                                    <h2 className="text-white">{card?.title}</h2>
                                    <p className="text-md md:text-lg text-white w-[90%] text-left md:text-center pt-1 md:pt-2">
                                        {card?.description}
                                    </p>
                                </div>
                            </div>
                            <Button
                                theme={card?.cta?.theme}
                                themeHover={card?.cta?.themeHover}
                                internalLink={card?.cta?.internalLink}
                                arrow={card?.cta?.arrow}
                                ctaWidth={card?.cta?.ctaWidth}
                                title={card?.cta?.text}
                                className="justify-center bg-sage-darker text-white hover:bg-near-black border-none hover:border-none text-black hover:text-white transition-colors duration-200"
                            >
                                {card?.cta?.text}
                            </Button>
                            {card?.text && <RichText className="mt-3" text={card?.text} />}
                        </div>
                    ))
                }
            </div>
            {bottomText && <RichText className="mt-4 w-full text-center md:text-left" text={bottomText} />}
        </div>
    )
}

export default NewHero;
